export default __webpack_public_path__ + "625e2fee1cbd4f3ac9fb525d7e423916.png";